<template>
<div class="drawerWrap roleAddOrEdit">
  <div class="drawerBody">
      <el-form class="addform" ref="addform" :model="addform" :rules="addformRules" v-if="!nextFlag" label-width="120px">
        <el-form-item label="租户昵称" prop="nickName">
          <el-input v-model="addform.nickName" placeholder="请输入租户昵称" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="租户登录名" prop="loginName">
          <el-input v-model="addform.loginName" placeholder="请输入租户登录名" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="租户密码" prop="pwd" v-if="addOrEditPar.type=='add'">
          <el-input v-model="addform.pwd" placeholder="请输入租户登录密码" type="password" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="addform.tel" placeholder="请输入联系电话" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮件地址" prop="email">
          <el-input v-model="addform.email" placeholder="请输入邮件地址" maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="启用预设角色" prop="preInstallRole">
          <el-radio-group v-model="addform.preInstallRole">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>

        </el-form-item>
        <el-form-item label="通道选择" >
          <el-checkbox-group v-model="addform.channels">
            <el-checkbox :label="item" v-for="(item,index) in channelArr" :key="index" name="channels"></el-checkbox>
          </el-checkbox-group>

        </el-form-item>
        <el-form-item label="系统区域" prop="region">
            <el-cascader v-model="addform.region" :options="proviceCityOptions" ></el-cascader>
        </el-form-item>
        
        <el-form-item label="租户描述" prop="comment">
          <el-input type="textarea" v-model="addform.comment" placeholder="请输入租户描述" maxlength="80"></el-input>
        </el-form-item>
      </el-form>
      <div  v-else>
        <!-- <tree-table @treeToSubmitIds="treeToSubmitIds" :dialogType="addOrEditPar.type" :moduleIds="addform.moduleIds"></tree-table>         -->
        <tree-table v-if="sendTreeFlag" :sendTreeData="sendTreeData" :modulesData="modulesData" :treeTableLabel="treeTableLabel" :checkedArray="checkedArray" :modulescheckedArray="editCheckedModulesIds" :isEdit="addOrEditPar.type === 'edit'" @toParentChecked="getModulesArray" @chooseAll='chooseAll' ref="treeRef" @halfCheckNode="halfCheckNode" @sendCheckNode="sendCheckNode"></tree-table>
      </div>
    <!-- </el-scrollbar> -->
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="nextTip" v-if="!nextFlag">下一步</el-button>
    <el-button type="primary" @click="lastTip" v-if="nextFlag">上一步</el-button>
    <el-button type="primary" @click="formSubmit" v-if="nextFlag" :loading="btnLoading">{{ btnLoading ? '提交中' : '提交' }}</el-button>
  </div>
</div>
</template>

<script>
import TreeTable from '@/components/childOrgManagement/TreeTable'
import { checkKeyboardContinuousChar } from '@/utils/validate'
export default {
  components: {
    TreeTable
  },
  props: {
    addOrEditPar: {
      type: Object,
      default: () => ({})
    },
    btnLoading :{
      type: Boolean,
      default: () => (false)
    },
  },
  data() {
    let scope = this;
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('租户登录名不能为空'));
      } else if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        callback(new Error('租户登录名中不能含有汉字'));
      } else if (value.length > 20) {
        callback(new Error('租户登录名必须在20个字符以内'));
      } else {
        console.log(`scope.tenantId`, scope.tenantId)
        if (value != (scope.tenantId === 0 ? "" : scope.addform.loginName)) {
          scope.request.get(`/front/system/tenant/exists/loginName/${scope.tenantId}?loginName=${value}`
        /*   , {
            params: {
              loginName: value
            }
          } */
          ).then(rs => {
            if (rs.code === 200) {
              if (rs.data) {
                callback(new Error('该租户登录名已被占用'));
              } else {
                callback();
              }
            }
          })
        } else {
          callback();
        }
      }
    };
    const validatePasswd = (rule, value, callback) => {
      // 必须包含大小写字母、数字、特殊字符
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=_！]).+$/
      //不能相同字符（如111、aaa）连续3位或3位以上
      const regex1 = /(\w)*(\w)\2{2}(\w)*/g

      if (value === '') {
        callback(new Error('请输入租户密码'));
      } else if (value.length < 8 || value.length > 30) {
        callback(new Error('租户密码必须在8~30个字符之间'));
      } else if (!regex.test(value)) {
        callback(new Error('密码必须包含大小写字母、数字、特殊字符[!@#$%^&+=_]'))
      } else if (regex1.test(value)) {
        callback(new Error('密码不能含有相同字符（例如111、aaa）连续3位或3位以上'))
      } else if (checkKeyboardContinuousChar(value)) {
        callback(new Error('密码不能含有标准键相邻按键组合（例如ASDFG,QWERTY）'))
      } else {
        // 不能连续字符（如123、abc）连续3位或3位以上
        for (let i = 1; i < value.length - 1; i++) {
          let firstIndex = value[i - 1].charCodeAt()
          let secondIndex = value[i].charCodeAt()
          let thirdIndex = value[i + 1].charCodeAt()
          if ((thirdIndex - secondIndex == 1) && (secondIndex - firstIndex == 1)) {
            callback(new Error('密码禁止设置递增的字母或数字（例如abc,123）连续3位或3位以上!'))
          } else {
            callback()
          }
        }
      }
    };
    const validateTelNumber = (rule, value, callback) => {
      const cellphone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!value) {
        callback(new Error('联系电话不能为空'));
      } else {
        if (!cellphone.test(value)) {
          callback(new Error('您输入的号码格式不正确'));
        } else {
          if (value != (scope.tenantId === 0 ? "" : scope.addform.tel)) {
            scope.request.get(`/front/system/tenant/exists/tel/${scope.tenantId}?tel=${value}`
           /*  , {
              params: {
                tel: value
              }
            } */
            ).then(rs => {
              if (rs.code === 200) {
                if (rs.data) {
                  callback(new Error('该租户联系电话已被占用'));
                } else {
                  callback();
                }
              }
            })
          } else {
            callback();
          }
        }
      }
    };
    const validateEmailNumber = (rule, value, callback) => {
      const cellemail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!value) {
        callback(new Error('邮箱地址不能为空'));
      } else {
        if (!cellemail.test(value)) {
          callback(new Error('您输入的邮箱地址格式不正确'));
        } else {
          if (value != (scope.tenantId === 0 ? "" : scope.addform.email)) {
            scope.request.get(`/front/system/tenant/exists/email/${scope.tenantId}?email=${value}`
          /*   , {
              params: {
                email: value
              }
            } */
            ).then(rs => {
              if (rs.code === 200) {
                if (rs.data) {
                  callback(new Error('该租户邮箱已被占用'));
                } else {
                  callback();
                }
              }
            })
          } else {
            callback();
          }
        }
      }
    };
    const validateNickName = (rule, value, callback) => {
      let numReg = /^[0-9]*$/;
      if (numReg.test(value)) {
        value = value.toString();
      }
      if (!(value && value.length > 0)) {
        callback(new Error('租户昵称不能为空'))
      }else {
        callback()
      }
    }
    const validateRegion = (rule, value, callback) => {
      let numReg = /^[0-9]*$/;
      if (numReg.test(value)) {
        value = value.toString();
      }
      if (!(value && value.length > 0)) {
        callback(new Error('区域不能为空'))
      }else {
        callback()
      }
    }
    return {
      modulesData: [],
      modulescheckedArray: [],
      editCheckedModulesIds: [1, 2, 3, 4, 5],
      treeTableLabel: ["模块名称", "模块地址"],
      modulesCount: 0,
      //判断租户名称是否与本次名称相同
      onceUsername: "",
      checkedArray: [1, 2, 3, 4, 5],
      // 树节点选中传入的值-----------------
      modulesCheckArr: [],
      // 树节点选中传入的值-----------------
      // 父穿子-----tree
      sendTreeFlag: false,
      sendTreeData: [],
      curTabIndex: 0,
      chooseAllFlag: '',
      // 添加========================
      nextFlag: false,
      addform: {
        loginName: '',
        pwd: '',
        tel: '',
        email: '',
        nickName: '',
        comment: '',
        preInstallRole: "true",
        channels: ["微信","短信","电话","API推送","websocket"],
        channel: '',
        moduleIds:[],
        region:[999]
      },
      channelArr: [],
      tenantId: 0,
      // 树-----
      moduleIds: [],
      // 树-----

      addformRules: {
        loginName: [{
          required: true,
          validator: validateUsername,
          trigger: 'blur'
        }],
        preInstallRole: [{
          required: true,
          // validator: validateUsername,
          trigger: 'blur'
        }],
        region: [{
          required: true,
          validator: validateRegion,
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          validator: validateNickName,
          trigger: 'blur'
        }],
        pwd: [{
          required: true,
          validator: validatePasswd,
          trigger: 'blur'
        }],
        tel: [{
          required: true,
          validator: validateTelNumber,
          trigger: 'blur'
        }],
        email: [{
          required: true,
          validator: validateEmailNumber,
          trigger: 'blur'
        }],
      },
      // 添加========================
       //省市选择 ======
      proviceCityOptions: [],
      ids:[],
      halfModuleIds:[]
    }
  },
  mounted() {
    this.initData()
  },
  created() {
    console.log(`this.addOrEditPar`, this.addOrEditPar)
    this.init();
  },
  methods: {
    getModulesArray(data) {
      this.modulescheckedArray = data;
    },
    
    // ----------------------------------------------------
    //树节点选中接收值
    sendCheckNode(checkArr) {
      console.log(checkArr)
      this.modulesCheckArr = checkArr
      this.ids=checkArr
      this.moduleIds=checkArr
      // console.log(this.modulesCheckArr)
    },
    // ----------------------------------------------------
       //树节点半选中接收值
    halfCheckNode(checkArr) {
      console.log(checkArr)
      this.halfModuleIds=checkArr
      // console.log(this.halfModuleIds)
    },
    // ----------------------------------------------------

    chooseAll(flag) {
      console.log(flag)
      console.log(this.modulesData);
      console.log(this.$refs.treeRef.$refs.treeTableTree.getCheckedNodes());
      if (flag) {
        this.$refs.treeRef.$refs.treeTableTree.setCheckedNodes(this.modulesData)
      } else {
        this.$refs.treeRef.$refs.treeTableTree.setCheckedKeys([])
      }
      // this.modulesData
    },
    //初始化=========
    init() {
      // this.getTreeList()
      this.getChanleArr()
      this.getProvice()
      if (this.addOrEditPar.type === 'edit') {
        this.getEditData()
        this.tenantId = this.addOrEditPar.tenantId
      } else {
        this.tenantId = 0
        this.$nextTick(() => {
          this.$refs.addform.resetFields()
          // this.addform = {}
          // this.modulescheckedArray = []
         
        })
      }
    },
    async getEditData(){
      const {code,data} = await this.request.get(`/front/system/tenant/queryById?id=${this.addOrEditPar.row.id}`)
      if(code !=200) {
        // return this.$message.error('获取编辑数据失败')
        return
      }
      console.log(`dataedit`, data)
      let region = this.addOrEditPar.row.region.split('_')
      region=region.map(item=>item*1)
      console.log(`object`, region)
      this.addform = {...data,channels:data.channel ? data.channel.split(',') : null,preInstallRole:data.isPreRole ? "true": "false",region}
      // this.sendTreeFlag = true
      if (this.addOrEditPar.type == "edit") {
        this.sendTreeData = data.moduleIds
        this.moduleIds=data.moduleIds
        this.halfModuleIds=data.halfModuleIds
      } else {
        this.sendTreeData = []
        this.moduleIds=[]
        this.halfModuleIds=[]
      }
    },
    //获取全部树id
    //  async getTreeList() {
    //    let params={
    //      id:this.storage.getSession("userId")
    //    }
    //   const {
    //     code,
    //     msg,
    //     data
    //   } = await this.request.get('/front/system/tenant/queryById',params)
    //   if (code !== 200) {
    //     if(code==500){
    //       return this.$message.error(msg);
    //     }
    //   }
    // console.log(`data`, data)
    //     this.sendTreeFlag = true
    //     if (this.addOrEditPar.type == "edit") {
    //       this.sendTreeData = data.moduleIds
    //     } else {
    //       this.sendTreeData = []
    //     }
    // // let ids = []
    // // data.map(item=>{
    // //   if(item.children){
    // //     item.children.map(itemitem=>{
    // //       ids.push(itemitem.value)
    // //     })
    // //       ids.push(item.value)      
    // //   }else {
    // //     ids.push(item.value) 
    // //   }
    // // })
    // // this.ids = ids
    // },
    async initData() {
      const {
        data: res
      } = await this.request.get("/front/system/module/query/distributeTree");
      console.log(res);
      
      // this.sendTreeFlag = true
      this.modulesData = res;
    },
    //通道项=========
    async getChanleArr() {
      const {
        code,
        msg,
        data
      } = await this.request.get('/front/system/config/query/SYS_NOTICE_CHANNEL')
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
      }
      console.log(`data`, data)
      this.channelArr = [...data.split(',')]
    },
    //通道项=========
    // 树======================
    treeToSubmitIds(ids){
      this.moduleIds = ids
    },
   
    // 树======================
    // 提交================
    nextTip() {
      this.$refs.addform.validate((valid) => {
        if (valid) {
           if (this.addOrEditPar.type === 'add') {
             this.addform.moduleIds  =this.ids
           }
          this.nextFlag = true
          this.sendTreeFlag=true
          this.$emit('changeWidth', "750px")
        } else {
          this.msg.error('请正确填写相关信息！')
          return
        }
      })

    },
    lastTip() {
      this.nextFlag = false
      this.sendTreeFlag=false
      this.$emit('changeWidth', "500px")
    },
    formSubmit() {
      console.log(`12121`, 12121)
      let region = null
      if(this.addform.region.length==1){
        region =  this.addform.region[0]       
      }else {
        region =this.addform.region[0]+"_"+this.addform.region[1]
      }
      let form = {
        ...this.addform,
        channel: this.addform.channels.join(','),
        moduleIds: this.moduleIds.join(','),
        halfModuleIds:this.halfModuleIds.join(','),
        region,
      // par.pwd = md5(par.pwd)


      }
      delete form.channels
      console.log(`form`, form)
      this.$emit('formSubmit',form)
    },

    // 提交================
    cancelHandle() {},
    //重置==========================
    resetHandle() {
      this.$refs.addform.resetFields()
    },
    //重置==========================

    // 验证规则==========================

    // 验证规则==========================
        // 省市======
    async getProvice() {
      const {
        code,
        data,
        msg
      } = await this.request.get('/front/region/queryAll')
      if (code != 200) {
        // return this.$message.error(msg)
        return
      }
      let proviceCityOptions = data.map(item => {
        if (item.cities.length > 0) {
          item.label = item.province
          // item.value = [item.longitude, item.latitude].toString()
          item.value = item.id
          // delete item.province
          delete item.longitude
          delete item.latitude
          item.cities.map(itemitem => {
            itemitem.label = itemitem.province
            // itemitem.value = [itemitem.longitude, itemitem.latitude].toString()
            itemitem.value = itemitem.id

            delete itemitem.province
            delete itemitem.longitude
            delete itemitem.latitude
            delete itemitem.province
            itemitem.label = itemitem.city
            delete itemitem.city
            // itemitem = [{value:item.id,label:`~全${item.province}`},...itemitem]
            // itemitem.unshift({value:item.id,label:`~全${item.province}`})
            return itemitem
          })
          item.children = [...item.cities]
          delete item.cities
            item.children.unshift({value:item.id,label:`全${item.province}`})
          return item
        } else {
          item.label = item.province
          // item.value = [item.longitude, item.latitude].toString()
          item.value = item.id
          delete item.province
          delete item.longitude
          delete item.latitude
          return item
        }
      })
      proviceCityOptions.unshift({label:'中国',value:999})
      this.proviceCityOptions = proviceCityOptions
    },
  }
}
</script>

